<template>
    <div class="contact-wrapper">
        <div class="contact__header">
            <p>Historia rozmów AI</p>
        </div>
        <div class="contact__list">
            <div class="contact__list-item">

            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>

</style>
<script setup lang="ts">
</script>